export * from './esm/vite-compatible-readable-stream.js'
export { default } from './esm/vite-compatible-readable-stream.js'
